import { render, staticRenderFns } from "./UcExpiringContractNotificationCard.yaml?vue&type=template&id=22d4a679&component"
import script from "./UcExpiringContractNotificationCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcExpiringContractNotificationCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports